import React, { useState } from 'react';
import Select from "react-select";
import DatePicker, { dateHelpers } from '../../../components/utils/datepicker';
import api from '../../../config/axios';
import Swal from 'sweetalert2';
import { FaFilter,FaEye } from 'react-icons/fa';

import { autoCompleteColaboradores } from "../../../components/utils/autocompletes";
import DetalhesComissoesModal from './modals/Detalhes';


const Comissoes = () => {
    const [error, setError] = useState(null);
    const [comissoes, setComissoes] = useState([]);
    const [periodo, setPeriodo] = useState(null);
    const [filtroAplicado, setFiltroAplicado] = useState(false);
    const [colaboradorFiltrado, setColaboradorFiltrado] = useState(null);
    const [modalDetalhesAberto, setModalDetalhesAberto] = useState(false);
    const [filtroComissaoSelecionado, setFiltroComissaoSelecionado] = useState(null);

    const { inputPesquisaColaborador, colaboradoresOptions, handleAutoCompleteColaboradores, handleFocusColaboradores } = autoCompleteColaboradores();

    const [filtros, setFiltros] = useState({
        data_inicio: '',
        data_fim: '',
        colaborador: ''
    });

    const convertDateToISO = (dateString) => {
        if (!dateString || dateString.includes('_')) return null;

        const [day, month, year] = dateString.split('/');
        if (day && month && year && day.length === 2 && month.length === 2 && year.length === 4) {
            return `${year}-${month}-${day}`;
        }
        return null;
    };

    const fetchComissoes = async (aplicarFiltro = false) => {
        try {
            if (aplicarFiltro || filtroAplicado) {
                const dataInicioISO = convertDateToISO(filtros.data_inicio);
                const dataFimISO = convertDateToISO(filtros.data_fim);

                const params = new URLSearchParams({
                    ...(dataInicioISO && { dataInicio: dataInicioISO }),
                    ...(dataFimISO && { dataFim: dataFimISO }),
                    ...(filtros.colaborador && { idColaborador: filtros.colaborador.value })
                });

                Swal.fire({
                    title: "Carregando...",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
    
                const response = await api.get(`/comissao?${params}`);

                if (response.data.success) {
                    Swal.close();
                    setComissoes(response.data.data.comissoes || []);
                    setPeriodo(response.data.data.periodo);
                    setColaboradorFiltrado(filtros.colaborador); 
                    setFiltroAplicado(true);
                    setError(null);
                } else {
                    Swal.close();
                    setError('Erro ao carregar os dados de comissão.');
                }
            } else {
                setComissoes([]);
                setPeriodo(null);
                setError(null);
            }
        } catch (err) {
            Swal.close();
            setError('Erro ao carregar as comissões.');
        }
    };

    const handleFiltroChange = (field, value) => {
        setFiltros(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleFiltrar = () => {
        const dataInicioISO = convertDateToISO(filtros.data_inicio);
        const dataFimISO = convertDateToISO(filtros.data_fim);

        if (!dataInicioISO || !dataFimISO) {
            Swal.fire('Atenção', 'Por favor, preencha data de início e data de fim.', 'warning');
            return;
        }

        setError(null);
        fetchComissoes(true);
    };

    const limparFiltros = () => {
        setFiltros({
            data_inicio: '',
            data_fim: '',
            colaborador: ''
        });
        setFiltroAplicado(false);
        setPeriodo(null);
        setComissoes([]);
        setColaboradorFiltrado(null);
        setError(null);
    };

    const formatarMoeda = (valor) => {
        if (!valor) return 'R$ 0,00';
        return parseFloat(valor).toLocaleString('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        });
    };

    const calcularTotalGeral = () => {
        return comissoes.reduce((total, comissao) => total + comissao.totalComissao, 0);
    };

    const abrirDetalhesComissao = (comissao) => {
        setFiltroComissaoSelecionado({
            colaborador_id: comissao.colaborador_id,
            colaborador_nome: comissao.colaborador,
            inicio: filtros.data_inicio,
            fim: filtros.data_fim
        });
        setModalDetalhesAberto(true);
    };

    const fecharModalDetalhes = () => {
        setModalDetalhesAberto(false);
        setFiltroComissaoSelecionado(null);
    };

    return (
        <div className="container-fluid">
            <div className="card">
                <div className="card-body">
                    <div className="row mt-3">
                        <div className="col-12">
                            <h4 className="fw-bold">Comissões</h4>
                        </div>
                    </div>

                    <div className="row mt-4 mb-4">
                        <div className="col-lg-3 col-12">
                            <label className="form-label fw-bold">Data De</label>
                            <DatePicker
                                selected={dateHelpers.stringToDate(filtros.data_inicio)}
                                onChange={dateHelpers.createOnChangeHandler((formattedDate) =>
                                    handleFiltroChange('data_inicio', formattedDate)
                                )}
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-3 col-12 mt-lg-0 mt-3">
                            <label className="form-label fw-bold">Data Até</label>
                            <DatePicker
                                selected={dateHelpers.stringToDate(filtros.data_fim)}
                                onChange={dateHelpers.createOnChangeHandler((formattedDate) =>
                                    handleFiltroChange('data_fim', formattedDate)
                                )}
                                className="form-control"
                            />
                        </div>
                        <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                            <label className="form-label fw-bold">Colaborador</label>
                            <Select
                                options={colaboradoresOptions}
                                onInputChange={(value) => {
                                    handleAutoCompleteColaboradores(value);
                                }}
                                onFocus={handleFocusColaboradores}
                                onChange={(value) => handleFiltroChange('colaborador', value)}
                                placeholder="Digite o nome do colaborador"
                                isClearable
                                menuPlacement="auto"
                                menuPosition="fixed"
                                noOptionsMessage={() => "Sem opções"}
                                value={filtros.colaborador}
                            />
                        </div>
                        <div className="col-lg-2 col-12 mt-lg-0 mt-3 d-flex align-items-end">
                            <div className="d-flex gap-2 w-100 justify-content-end">
                                <button
                                    className="btn btn-outline-secondary"
                                    onClick={limparFiltros}
                                >
                                    Limpar
                                </button>
                                <button
                                    className="btn btn-custom-primary"
                                    onClick={handleFiltrar}
                                >
                                    <FaFilter /> Filtrar
                                </button>
                            </div>
                        </div>
                    </div>

                    {error ? (
                        <p className="error-message">{error}</p>
                    ) :  (
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead className="table-custom-primary">
                                    <tr>
                                        <th>Colaborador</th>
                                        <th className="text-center">Qtd. Serviços</th>
                                        <th className="text-center">Qtd. Produtos</th>
                                        <th className="text-center text-nowrap">Valor Total</th>
                                        <th className="text-center text-nowrap">Comissões Totais</th>
                                        <th className="text-center">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                      {comissoes.map((comissao, index) => (
                                          <tr key={index}>
                                             <td className="text-nowrap">
                                                 {comissao.colaborador}
                                             </td>
                                             <td className="text-center">
                                                 {comissao.quantidadeServicos}
                                             </td>
                                             <td className="text-center">
                                                 {comissao.quantidadeProdutos}
                                             </td>
                                             <td className="text-center text-nowrap">
                                                 {formatarMoeda(comissao.totalValorBase)}
                                             </td>
                                             <td className="text-center text-nowrap fw-bold text-success">
                                                 {formatarMoeda(comissao.totalComissao)}
                                             </td>
                                             <td className="text-center">
                                                 <button
                                                     className="btn btn-custom-secondary btn-sm"
                                                     onClick={() => abrirDetalhesComissao(comissao)}
                                                     title="Ver Detalhes"
                                                 >
                                                     <FaEye />
                                                 </button>
                                             </td>
                                         </tr>
                                            ))}
                                            {!colaboradorFiltrado && (
                                                <tr className="table-secondary fw-bold">
                                                    <td>TOTAL GERAL</td>
                                                    <td className="text-center">
                                                        {comissoes.reduce((total, c) => total + c.quantidadeServicos, 0)}
                                                    </td>
                                                    <td className="text-center">
                                                        {comissoes.reduce((total, c) => total + c.quantidadeProdutos, 0)}
                                                    </td>
                                                    <td className="text-center text-nowrap">
                                                        {formatarMoeda(comissoes.reduce((total, c) => total + c.totalValorBase, 0))}
                                                    </td>
                                                    <td className="text-center text-nowrap text-success">
                                                        {formatarMoeda(calcularTotalGeral())}
                                                    </td>
                                                    <td className="text-center"></td>
                                                </tr>
                                            )}
                                </tbody>
                            </table>
                        </div>
                    )}


                </div>
            </div>
            <div style={{ height: '50px' }}></div>

            {modalDetalhesAberto && filtroComissaoSelecionado && (
                <DetalhesComissoesModal
                    idColaborador={filtroComissaoSelecionado.colaborador_id}
                    nomeColaborador={filtroComissaoSelecionado.colaborador_nome}
                    inicio={filtroComissaoSelecionado.inicio}
                    fim={filtroComissaoSelecionado.fim}
                    onClose={fecharModalDetalhes}
                />
            )}
        </div>
    );
};

export default Comissoes;
